/** Randevu OTP sonrası oluşan garanti stok telafi belgesi (cari borç oluşturmaz). */
export const isGarantiOtomatikTelafiSiparis = (s) => {
  if (!s) return false;
  if (s.otomatikSiparis) return true;
  if (Array.isArray(s.islemGecmisi) && s.islemGecmisi.some((e) => e.eylem === 'OtomatikSiparisOlusturuldu')) {
    return true;
  }
  const not = String(s.not || '').toLowerCase();
  return (
    not.includes('otomatik')
    && (not.includes('fiziksel stok') || not.includes('parça denge') || not.includes('telafi'))
  );
};

export const getOtomatikTelafiTipLabel = (s) => {
  if (s?.konsinyeOzDonusum) return 'Garanti otomatik (konsinye→öz)';
  return 'Garanti otomatik telafi';
};

export const getSiparisTipLabel = (s) => {
  if (isGarantiOtomatikTelafiSiparis(s)) return getOtomatikTelafiTipLabel(s);
  if (s?.konsinyeOzDonusum) return 'Konsinye→öz';
  if (s?.konsinye) return 'Konsinye';
  return s?.garantiDahilinde ? 'Garanti dahilinde' : 'Doğrudan Sipariş';
};

/** Liste/detay fiyat sütunu — otomatik telafide cari bedel yok. */
export const formatSiparisListeFiyat = (s, formatCurrency) => {
  if (isGarantiOtomatikTelafiSiparis(s)) return '0 ₺';
  if (s?.garantiDahilinde || s?.konsinye) return '—';
  return formatCurrency(s?.toplamTutar);
};

export const referansBirimFiyat = (p) => {
  if (p?.fiyat != null && Number.isFinite(Number(p.fiyat))) return Number(p.fiyat);
  if (p?.fiyatgarantiSnapshot != null && Number.isFinite(Number(p.fiyatgarantiSnapshot))) {
    return Number(p.fiyatgarantiSnapshot);
  }
  return null;
};
